"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeaturesAvailable = void 0;
var react_1 = require("react");
var types_1 = require("@shopify/app-bridge/actions/Features/types");
var useAppBridge_1 = require("../../useAppBridge");
/**
 * useFeaturesAvailable hook
 *
 * @remarks
 * React hook that wraps the Shopify App Bridge getFeaturesAvailable method.
 *
 * @public
 */
function useFeaturesAvailable() {
    var _this = this;
    var query = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        query[_i] = arguments[_i];
    }
    var app = useAppBridge_1.useAppBridge();
    var _a = react_1.useState(), state = _a[0], setState = _a[1];
    var queryRef = react_1.useRef([]);
    var refresh = react_1.useCallback(function () {
        var isUnmounted = false;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var features;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, app.featuresAvailable.apply(app, queryRef.current)];
                    case 1:
                        features = _a.sent();
                        if (!isUnmounted) {
                            setState(function (currentFeatures) {
                                if (JSON.stringify(currentFeatures) === JSON.stringify(features)) {
                                    return currentFeatures;
                                }
                                return features;
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            isUnmounted = true;
        };
    }, [app]);
    react_1.useEffect(function () {
        queryRef.current = query;
        return refresh();
    }, [JSON.stringify(query)]);
    react_1.useEffect(function () {
        var onRefreshCleanup;
        var unsubscribe = app.subscribe(types_1.Action.UPDATE, function () {
            onRefreshCleanup = refresh();
        });
        return function () {
            unsubscribe();
            onRefreshCleanup === null || onRefreshCleanup === void 0 ? void 0 : onRefreshCleanup();
        };
    }, [app, refresh]);
    return state;
}
exports.useFeaturesAvailable = useFeaturesAvailable;
